<template>
  <at-panel v-if="isLoading">
    <template #header>
      <div class="w-1/2">
        <at-skeleton type="row" />
      </div>
    </template>
    <div class="-m-2">
      <div class="p-2">
        <at-skeleton type="row" />
      </div>
      <div class="p-2">
        <at-skeleton type="row" />
      </div>
    </div>
  </at-panel>

  <at-panel v-else :title="$t('entities.rejectCase.info.title')">
    <div class="flex flex-wrap justify-between items-center">
      <div class="w-full lg:w-1/2 mt-3">
        <p class="text-gray-500 dark:text-gray-300 text-sm">{{ $t('entities.rejectCase.info.clientName') }}</p>
        <h4 class="text-gray-900 dark:text-white font-medium">{{ rejectCase.client_name }}</h4>
      </div>
      <div class="w-full lg:w-1/2 mt-3">
        <p class="text-gray-500 dark:text-gray-300 text-sm">{{ $t('entities.rejectCase.info.clientPhone') }}</p>
        <h4 class="text-gray-900 dark:text-white font-medium">{{ formatPhone(rejectCase.client_phone) }}</h4>
      </div>
      <div class="w-full lg:w-1/2 mt-3">
        <p class="text-gray-500 dark:text-gray-300 text-sm">{{ $t('entities.rejectCase.info.date') }}</p>
        <h4 class="text-gray-900 dark:text-white font-medium">{{ formatDate(parseISO(rejectCase.date)) }}</h4>
      </div>
      <div class="w-full lg:w-1/2 mt-3">
        <p class="text-gray-500 dark:text-gray-300 text-sm">{{ $t('entities.rejectCase.info.note') }}</p>
        <h4 class="text-gray-900 dark:text-white font-medium">{{ rejectCase.note }}</h4>
      </div>
    </div>
  </at-panel>
</template>

<script setup>
  import { parseISO } from 'date-fns';

  import { AtPanel, AtSkeleton } from '@packages/aliftech-ui';

  import { formatPhone, formatDate } from '@/to-fsd/shared/lib';

  defineProps({
    rejectCase: {
      type: Object,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  });
</script>
